import { batch, useDispatch, useSelector } from 'react-redux';
import { memo } from 'react';
import allActions from '../../actions/product_builder';
import { Button } from '@material-ui/core';
import { isPremiumOption } from '../../utils/isPremium';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';

let FaceplateExcerpt = ({ faceplate, isCurrent, setSelected }) => {
    const dispatch = useDispatch();
    const currentSide = useSelector((state) => state.rootReducer.settingsOptions.currentSide);
    // const none = useSelector((state) => state.rootReducer.currentModel.currentModel.artwork.none);

    let setFaceplate = () => {
        if (currentSide === 'both') {
            batch(() => {
                dispatch(allActions.faceplateActions.setActiveFaceplateOption(faceplate));
                dispatch(allActions.priceActions.setBothFaceplatePrice(faceplate));
                setSelected(faceplate.displayName);
                if (isPremiumOption(faceplate)) {
                    dispatch(
                        allActions.artworkActions.setLeftArtwork({
                            iconImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Icons/Clear-Translucent-Faceplate.icon.png',
                            displayName: 'None',
                            price: '0.00',
                            leftImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.left.png',
                            rightImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.right.png'
                        })
                    );
                    dispatch(
                        allActions.artworkActions.setRightArtwork({
                            iconImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Icons/Clear-Translucent-Faceplate.icon.png',
                            displayName: 'None',
                            price: '0.00',
                            leftImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.left.png',
                            rightImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.right.png'
                        })
                    );
                    dispatch(allActions.priceActions.setBothArtworkPrice({ price: '0' }));
                }
            });
        } else if (currentSide === 'left') {
            batch(() => {
                dispatch(allActions.faceplateActions.setLeftFaceplateOption(faceplate));
                dispatch(allActions.priceActions.setLeftFaceplatePrice(faceplate));
                setSelected(faceplate.displayName);
                if (isPremiumOption(faceplate)) {
                    dispatch(
                        allActions.artworkActions.setLeftArtwork({
                            iconImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Icons/Clear-Translucent-Faceplate.icon.png',
                            displayName: 'None',
                            price: '0.00',
                            leftImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.left.png',
                            rightImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.right.png'
                        })
                    );
                    dispatch(allActions.priceActions.setLeftArtworkPrice({ price: '0' }));
                }
            });
        } else if (currentSide === 'right') {
            batch(() => {
                dispatch(allActions.faceplateActions.setRightFaceplateOption(faceplate));
                dispatch(allActions.priceActions.setRightFaceplatePrice(faceplate));
                setSelected(faceplate.displayName);
                if (isPremiumOption(faceplate)) {
                    dispatch(
                        allActions.artworkActions.setRightArtwork({
                            iconImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Icons/Clear-Translucent-Faceplate.icon.png',
                            displayName: 'None',
                            price: '0.00',
                            leftImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.left.png',
                            rightImage:
                                'https://64-audio-product-configurator-images.s3.us-west-2.amazonaws.com/IEM+Designer+Files/Artwork/Logos/Artwork-None.right.png'
                        })
                    );
                    dispatch(allActions.priceActions.setRightArtworkPrice({ price: '0' }));
                }
            });
        }
    };

    return (
        <Button
            key={faceplate.displayName + ' ' + faceplate.SK}
            disableRipple={true}
            className={layout.pickerBtnContainer}
            onClick={() => {
                setFaceplate();
            }}
            onMouseEnter={() => setSelected(faceplate.displayName)}
            onMouseLeave={() => setSelected(null)}>
            <img
                alt={faceplate.SK}
                src={faceplate.iconImage}
                className={isCurrent ? buttons.btnCircleActive : buttons.btnCircle}
            />
        </Button>
    );
};

export default memo(FaceplateExcerpt);
